import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import {
	CockpitNav,
	GestureHint,
	MissionLaunchModal,
	MissionsPage,
	NavBar,
	SearchBar,
	ShipyardPage,
	Sidebar,
	SpaceCanvas,
	ToastContainer,
	TutorialProvider,
	WalletButton,
} from "./components";
import { useOrientationSync } from "./hooks/useOrientationSync";
import { fetchStarSystems } from "./services";
import { useFavouritesStore, useSpaceStore } from "./stores";

export default function App() {
	useOrientationSync();

	const activeTab = useSpaceStore((s) => s.activeTab);
	const setActiveTab = useSpaceStore((s) => s.setActiveTab);
	const setSystems = useSpaceStore((s) => s.setSystems);
	const setLoading = useSpaceStore((s) => s.setLoading);
	const setError = useSpaceStore((s) => s.setError);
	const isLoading = useSpaceStore((s) => s.isLoading);

	const systemsQuery = useQuery({
		queryKey: ["systems"],
		queryFn: fetchStarSystems,
	});

	useEffect(() => {
		if (systemsQuery.data) {
			setSystems(systemsQuery.data);
		}
	}, [systemsQuery.data, setSystems]);

	useEffect(() => {
		setLoading(systemsQuery.isLoading);
	}, [systemsQuery.isLoading, setLoading]);

	useEffect(() => {
		const error = systemsQuery.error;
		setError(error ? (error as Error).message : null);
	}, [systemsQuery.error, setError]);

	// Hydrate favourites from localStorage on mount
	useEffect(() => {
		useFavouritesStore.getState().hydrate();
	}, []);

	return (
		<div className="app">
			<SpaceCanvas />
			<NavBar />
			<SearchBar />
			<Sidebar />
			<GestureHint />

			{/* Wallet Button - Top Right */}
			<div className="wallet-overlay">
				<WalletButton />
			</div>

			{/* Transaction Notifications */}
			<ToastContainer />

			{/* Mission Launch Modal (triggered from planet sidebar) */}
			<MissionLaunchModal />

			{/* Onboarding Tutorial */}
			<TutorialProvider />

			{/* Cockpit HUD Navigation */}
			<CockpitNav />

			{/* Tab Content - Full Page Views */}
			{activeTab === "shipyard" && <ShipyardPage onClose={() => setActiveTab("explore")} />}
			{activeTab === "missions" && <MissionsPage onClose={() => setActiveTab("explore")} />}

			{isLoading && activeTab === "explore" && (
				<div className="loading-overlay">
					<div className="loading-spinner" />
					<span>Loading celestial data...</span>
				</div>
			)}
		</div>
	);
}
